import { create } from "zustand";

const useTaskTypes = create((set) => ({
    taskTypes: [],
    setTaskTypes: (taskTypes) => set({ taskTypes })
}));

export default useTaskTypes;